webpackJsonp(["core"],{

/***/ "/home/vsts/work/1/s/src/SCF/client/src/core/vendor/index.js":
/***/ (function(module, exports) {

// Note vendor js loaded with System in components directly


/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/banner-scroll/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(".scf_large-banner-scroll").on("click", function (e) {
    e.preventDefault();
    (0, _jquery2.default)("html, body").animate({
      scrollTop: (0, _jquery2.default)(this).parent().height()
    }, 500, "linear");
  });

  var topOfDivScroll = 0;
  if ((0, _jquery2.default)(".scf_large-banner-scroll").offset()) {
    topOfDivScroll = (0, _jquery2.default)(".scf_large-banner-scroll").offset().top * 0.8;
  }
  var windowsize = (0, _jquery2.default)(window).innerWidth();

  (0, _jquery2.default)(window).resize(function () {
    windowsize = (0, _jquery2.default)(window).innerWidth();
  });

  (0, _jquery2.default)(window).scroll(function () {
    if (windowsize > 768) {
      if ((0, _jquery2.default)(window).scrollTop() > topOfDivScroll) {
        (0, _jquery2.default)(".scf_large-banner-scroll").hide();
      } else (0, _jquery2.default)(".scf_large-banner-scroll").show();
    }
  });
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/buttons/analytics-trigger.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true dataLayer:true */
/**
 * Analytics Trigger
 *
 * Send google analytics on element events.
 *
 * @example
 *    <input
 *        type="radio"
 *        data-analytics-trigger
 *        data-analytics-trigger-on="click"
 *        data-analytics-trigger-event-name="checkboxClicked"
 *        data-analytics-trigger-some-value="foo"
 *        data-analytics-trigger-some-other-value="bar"
 *        data-analytics-trigger-yet-another-value="baz">
 *
 *    <input
 *        type="search"
 *        data-analytics-trigger
 *        data-analytics-trigger-on="click"
 *        data-analytics-trigger-extract-value-as="searchTerm"
 *        data-analytics-trigger-event-name="checkboxClicked">
 */

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-analytics-trigger]';
var ZERO = 0;

var AnalyticsTriggerPlugin = function () {
    function AnalyticsTriggerPlugin(element, options) {
        _classCallCheck(this, AnalyticsTriggerPlugin);

        this.element = element;
        this.options = options;
        this.$element = (0, _jquery2.default)(element);
        this.watching = null;
        this.$nodeType = this.$element.get(ZERO).nodeType;
        this.isFormField = ['input', 'textarea', 'select', 'button'].includes(this.$nodeType);

        this.watch();
    }

    _createClass(AnalyticsTriggerPlugin, [{
        key: 'watch',
        value: function watch() {
            this.watching = this.$element.on(this.options.on, this.trigger.bind(this));
        }
    }, {
        key: 'unwatch',
        value: function unwatch() {
            this.$element.off(this.watching);
        }
    }, {
        key: 'trigger',
        value: function trigger() {
            var _this = this;

            var data = Object.keys(this.options).filter(function (key) {
                return !['on', 'extractValueAs'].includes(key);
            }).reduce(function (result, key) {
                result[key] = _this.options[key];

                return result;
            }, {});

            if (this.isFormField && this.options.extractValueAs) {
                data[this.options.extractValueAs] = this.$element.val();
            }
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(data);
            }
        }
    }]);

    return AnalyticsTriggerPlugin;
}();

AnalyticsTriggerPlugin.DEFAULTS = {
    on: "click",
    event: null,
    extractValueAs: null
};

(0, _lib2.default)('analyticsTrigger', AnalyticsTriggerPlugin);

(0, _jquery2.default)(document).ready(function () {
    (0, _jquery2.default)(ELEMENT_SELECTOR)['analyticsTrigger']();
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/dropdown/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(".custom-select").each(function () {
    var classes = (0, _jquery2.default)(this).attr("class"),
        id = (0, _jquery2.default)(this).attr("id"),
        name = (0, _jquery2.default)(this).attr("name");
    var template = '<div class="' + classes + '">';
    var displayValue = (0, _jquery2.default)(this).val().length > 0 ? (0, _jquery2.default)(this).val() : (0, _jquery2.default)(this).attr("placeholder");
    template += '<span class="custom-select-trigger">' + displayValue + "</span>";
    template += '<div class="custom-options">';
    (0, _jquery2.default)(this).find("option").each(function () {
      var select = (0, _jquery2.default)(this).attr("selected") ? "selection" : "";
      template += '<span class="custom-option ' + select + '"' + ' data-value="' + (0, _jquery2.default)(this).attr("value") + '">' + (0, _jquery2.default)(this).html() + "</span>";
    });
    template += "</div></div>";

    (0, _jquery2.default)(this).wrap('<div class="custom-select-wrapper"></div>');
    (0, _jquery2.default)(this).hide();
    (0, _jquery2.default)(this).after(template);
  });

  (0, _jquery2.default)(".custom-select-trigger").on("click", function () {
    (0, _jquery2.default)("html").one("click", function () {
      (0, _jquery2.default)(".custom-select").removeClass("opened");
    });
    (0, _jquery2.default)(this).parents(".custom-select").toggleClass("opened");
    event.stopPropagation();
  });
  (0, _jquery2.default)(".custom-option").on("click", function () {
    (0, _jquery2.default)(this).parents(".custom-select-wrapper").find("select").val((0, _jquery2.default)(this).data("value"));
    (0, _jquery2.default)(this).parents(".custom-options").find(".custom-option").removeClass("selection");
    (0, _jquery2.default)(this).addClass("selection");
    (0, _jquery2.default)(this).parents(".custom-select").removeClass("opened");
    (0, _jquery2.default)(this).parents(".custom-select").find(".custom-select-trigger").text((0, _jquery2.default)(this).text());
    (0, _jquery2.default)(this).parents("form.scf-filter__form").trigger("submit");
  });
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/address-validation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-address-validation]';
var FORM_WRAPPER_SELECTOR = 'data-form-wrapper-element';
var SINGLE_LINE_FIELD_SELECTOR = 'data-single-line-field';
var SINGLE_LINE_FIELDS_SELECTOR = 'data-single-line-fields';
var ADDRESS_LINE_0_SELECTOR = '.address-line-0';
var PLUGIN_NAME = 'addressValidation';
var MODULE_NAME = 'app.core/modules/address-validation';

var AddressValidation = function () {
	function AddressValidation(element, options) {
		_classCallCheck(this, AddressValidation);

		this.element = element;
		this.options = options;
		this.$element = (0, _jquery2.default)(element);
		this.$parentEl = (0, _jquery2.default)(this.$element.attr(FORM_WRAPPER_SELECTOR));
		this.$addressLine0 = this.$parentEl.find(ADDRESS_LINE_0_SELECTOR);
		this.isSingleLine = typeof this.$element.attr(SINGLE_LINE_FIELD_SELECTOR) !== 'undefined';
		this.singleLineFields = typeof this.$element.attr(SINGLE_LINE_FIELDS_SELECTOR) !== 'undefined' ? this.$element.attr(SINGLE_LINE_FIELDS_SELECTOR) : '';

		this.watchGoogleMapApiError();
		this.init();
		this.preventSubmit();
	}

	_createClass(AddressValidation, [{
		key: 'watchGoogleMapApiError',
		value: function watchGoogleMapApiError() {
			var oldError = console.error;
			// Stops the input field from being disabled if issue with API
			var $element = this.$element;
			console.error = function (message) {
				if (message.toLowerCase().includes("google maps api error")) {
					$element.removeAttr('disabled');
					$element.attr('placeholder', '');
					$element.removeAttr('style', '');
					$element.parent().find('.field-validation-valid').hide();
				}

				oldError.apply(console, arguments);
			};
		}
	}, {
		key: 'preventSubmit',
		value: function preventSubmit() {

			if (this.$element.closest('form').length) {

				this.$element.on('keypress', function (event) {
					if (event.keyCode === 13) {
						event.preventDefault();
						log('preventSubmit.keypress', event.keyCode);
					}
				});
			}
		}
	}, {
		key: 'init',
		value: function init() {
			var options = {
				componentRestrictions: { country: this.options.countryCode }
			};

			if (this.singleLineFields.length > 0) {
				options['types'] = [this.singleLineFields];
			}

			var el = this.$element.attr('id');
			window.autocompleteObj = new google.maps.places.Autocomplete(document.getElementById(el), options);

			this.autocomplete = window.autocompleteObj;
			this.autocomplete.addListener('place_changed', this.fillInAddress.bind(this));
		}
	}, {
		key: 'fillInAddress',
		value: function fillInAddress() {
			var place = this.autocomplete.getPlace();
			this.$element.trigger({ type: 'place_selected', place: place });
			for (var component in this.options.componentForm) {
				var compElement = this.$parentEl.find('.' + component);
				if (typeof compElement !== 'undefined' && compElement.length > 0) {
					compElement.val('');
					compElement.attr('disabled', false);
				}
			}

			var addressLine0 = '';
			var addressLine1 = '';
			var premise = '';
			var subpremise = '';
			var route = '';
			var postBox = '';
			var postalTown = '';
			var administrative_area_level_2 = '';
			var locality = '';
			var state = '';
			var country = '';
			var postcode = '';
			var fullAddress = place.formatted_address;
			var singleLineFields = this.singleLineFields.length > 0 ? this.singleLineFields.split(',') : Array();

			for (var i = 0; i < place.address_components.length; i++) {
				var addressType = place.address_components[i].types[0];
				var compElement = this.$parentEl.find('.' + addressType);

				if (addressType == 'post_box') {
					postBox = place.address_components[i][this.options.componentForm['post_box']];
				}
				if (addressType == 'premise') {
					premise = place.address_components[i][this.options.componentForm['premise']];
				}
				if (addressType == 'subpremise') {
					subpremise = place.address_components[i][this.options.componentForm['subpremise']];
				}
				if (addressType == 'street_number') {
					addressLine1 = place.address_components[i][this.options.componentForm['street_number']];
				}
				if (addressType == 'route') {
					route = place.address_components[i][this.options.componentForm['route']];
				}
				if (addressType == 'postal_town') {
					postalTown = place.address_components[i][this.options.componentForm['postal_town']];
				}
				if (addressType == 'postal_code') {
					postcode = place.address_components[i][this.options.componentForm['postal_code']];
				}
				if (addressType == 'administrative_area_level_1') {
					state = place.address_components[i][this.options.componentForm['administrative_area_level_1']];
				}
				if (addressType == 'country') {
					country = place.address_components[i][this.options.componentForm['country']];
				}
				if (addressType == 'locality' || addressType == 'colloquial_area') {
					locality = place.address_components[i][this.options.componentForm['locality']];
				}
				if (addressType == 'administrative_area_level_2') {
					administrative_area_level_2 = place.address_components[i][this.options.componentForm['administrative_area_level_2']];
				}
				if (this.options.componentForm[addressType] && typeof compElement !== 'undefined' && compElement.length > 0) {
					var val = place.address_components[i][this.options.componentForm[addressType]];
					compElement.val(val);
				}
			}

			var latitudeElement = this.$parentEl.find('.latitude');
			var longitudeElement = this.$parentEl.find('.longitude');
			if (typeof latitudeElement !== 'undefined' && latitudeElement.length > 0) {
				var latitude = place.geometry.location.lat();
				var val = latitude;
				latitudeElement.val(val);
			}
			if (typeof longitudeElement !== 'undefined' && longitudeElement.length > 0) {
				var longitude = place.geometry.location.lng();
				var val = longitude;
				longitudeElement.val(val);
			}

			if (locality.length == 0) {
				locality = postalTown;
			}
			if (locality.length == 0) {
				locality = administrative_area_level_2;
			}

			var localityEl = this.$parentEl.find('.locality');
			if (typeof localityEl !== 'undefined') {
				localityEl.val(locality);
			}
			var add0 = subpremise.length > 0 ? subpremise + ' ' : '';
			add0.trim();

			var add1 = postBox.length > 0 ? 'PO BOX ' + postBox + ' ' : '';
			add1 += premise.length > 0 ? premise + ' ' : '';
			add1 += addressLine1.length > 0 ? addressLine1 + ' ' : '';
			add1 += route;
			add1.trim();

			var resultAddress = add1;
			resultAddress += " " + locality;
			resultAddress += " " + state;
			resultAddress += " " + postcode;
			resultAddress += " " + country;
			if (typeof this.$addressLine0 !== 'undefined' && this.$addressLine0.length == 0) {
				this.$addressLine0.val(add0);
			}

			if (!this.isSingleLine) {
				this.$element.val(add1);
			} else {
				this.$element.val(resultAddress);
			}

			(0, _jquery2.default)(document).trigger('address-validation-complete');
		}
	}]);

	return AddressValidation;
}();

AddressValidation.DEFAULTS = {
	componentForm: {
		post_box: 'long_name',
		premise: 'long_name',
		subpremise: 'long_name',
		street_number: 'short_name',
		sublocality_level_1: 'short_name',
		route: 'long_name',
		locality: 'long_name',
		administrative_area_level_1: 'short_name',
		administrative_area_level_2: 'short_name',
		country: 'long_name',
		postal_code: 'short_name',
		postal_town: 'short_name'
	},
	countryCode: (0, _jquery2.default)('meta[name="site.countryCode"]').attr('content')
};

(0, _lib2.default)(PLUGIN_NAME, AddressValidation);

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/category-and-product-selector.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

var _strings = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/strings.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-category-and-product-selector]';
var ELEMENT_ATTR = 'data-category-and-product-selector';
var PRODUCT_ELEMENT_SELECTOR = '[data-category-and-product-selector-product]';
var CATEGORY_ELEMENT_SELECTOR = '[data-category-and-product-selector-category]';
var CATEGORY_ELEMENT_CONTAINER_SELECTOR = '[data-category-and-product-selector-category-wrapper]';
var PRODUCT_WRAPPER_ELEMENT_SELECTOR = '[data-category-and-product-selector-product-wrapper]';
var PRODUCT_WRAPPER_FIELD_ATTR = 'data-category-and-product-selector-product-wrapper';
var PRODUCT_ATTR = 'data-selected-product';
var CATEGORY_ATTR = 'data-selected-category';
var PRODUCT_FIELD_NAME_ATTR = 'data-product-field-name';
var PRODUCT_FIELD_ATTRS_ATTR = 'data-product-field-attrs';
var ITEM_TEMPLATE_SELECTOR = '#productCategoryTemplate';
var CLASSNAME = "input-hidden";
var ATTRIBUTES_SELECTOR = '[data-attributes]';
var ATTRIBUTES_ATTR = 'data-attributes';
var HIDDEN_SELECTOR = '[data-category-and-product-selector-hidden]';
var HIDDEN_PRODUCT_SELECTOR = '[data-category-and-product-selector-product-hidden]';
var PLUGIN_NAME = 'CategoryAndProductSelector';

var CategoryAndProductSelector = function () {
    function CategoryAndProductSelector(element, options) {
        _classCallCheck(this, CategoryAndProductSelector);

        this.element = element;
        this.options = options;
        this.$element = (0, _jquery2.default)(element);
        this.$productElementWrapper = this.$element.find(PRODUCT_WRAPPER_ELEMENT_SELECTOR);
        this.productWrapperId = this.$productElementWrapper.attr(PRODUCT_WRAPPER_FIELD_ATTR);
        this.$productWrapperElement = (0, _jquery2.default)(this.productWrapperId);

        this.selectedProduct = this.$element.attr(PRODUCT_ATTR);
        this.selectedCategory = this.$element.attr(CATEGORY_ATTR);
        this.productFieldName = this.$element.attr(PRODUCT_FIELD_NAME_ATTR);
        this.productFieldAttrs = this.$element.attr(PRODUCT_FIELD_ATTRS_ATTR);
        this.$hiddenElement = this.$element.find(HIDDEN_SELECTOR);
        this.$hiddenProductElement = this.$element.find(HIDDEN_PRODUCT_SELECTOR);
        this.$categoryElementContainer = this.$element.find(CATEGORY_ELEMENT_CONTAINER_SELECTOR);
        this.itemTemplate = (0, _jquery2.default)(ITEM_TEMPLATE_SELECTOR).text();
        this.$attributesEl = this.$element.find(ATTRIBUTES_SELECTOR);
        this.attributes = this.$attributesEl.attr(ATTRIBUTES_ATTR);
        this.id = this.$element.attr(ELEMENT_ATTR);
        this.$errorElement = this.$categoryElementContainer.find('span');
        this.productSet = false;

        this.$productWrapperElement.hide();
        if (this.selectedProduct.length > 0 && this.selectedCategory.length == 0) {
            this.loadSelectedCategory();
        } else {
            this.loadCategories();
        }

        /* Jira SCF-269 - Extra form check to fix bug where a user could click next while the page was still loading and the
         'input[data-category-and-product-selector-product-hidden]' element was empty. This was happening intermittently 
         if moving quickly back and forwards between the first 2 steps and selecting different categories.
        */
        (0, _jquery2.default)('.getaquoteform button[name="__next"]').click(function (e) {

            if ((0, _jquery2.default)('input[data-category-and-product-selector-product-hidden]').length) {

                if (!(0, _jquery2.default)('input[data-category-and-product-selector-product-hidden]').val()) {
                    var form = (0, _jquery2.default)('.getaquoteform > form');
                    form.validate();

                    if (form.valid()) {
                        e.preventDefault();
                    }
                }
            }
        });
    }

    _createClass(CategoryAndProductSelector, [{
        key: 'SetCategoriesDropdown',
        value: function SetCategoriesDropdown(data) {
            var mod = this;
            var $errorEl = this.$errorElement.detach();
            _jquery2.default.each(data, function (i, v) {
                var selected = v.Checked || v.Value.replace(' ', '') == mod.selectedCategory ? "checked=checked" : "";

                var html = (0, _strings.mustache)(mod.itemTemplate, {
                    Name: mod.id + 'category',
                    Value: v.Value,
                    Label: v.Value,
                    ImageUrl: v.ImageUrl,
                    Id: v.Id,
                    Attributes: mod.attributes,
                    Selected: selected
                });
                mod.$categoryElementContainer.append(html);
            });

            this.$categoryElementContainer.append($errorEl);
            this.$categoryElement = this.$element.find(CATEGORY_ELEMENT_SELECTOR);
            this.watch();
        }
    }, {
        key: 'SetProductsDropdown',
        value: function SetProductsDropdown(data) {
            var mod = this;
            var $errorEl = this.$errorElement.detach();
            var hideProducts = true;
            mod.$productElementWrapper.empty();
            _jquery2.default.each(data, function (i, v) {
                var selected = v.Checked || v.Value.replace(' ', '') == mod.selectedProduct ? "checked=checked" : "";

                hideProducts = false;
                var html = (0, _strings.mustache)(mod.itemTemplate, {
                    Name: mod.productFieldName,
                    Value: v.Id,
                    Label: v.Value,
                    ImageUrl: v.ImageUrl,
                    Id: v.Id,
                    Attributes: mod.productFieldAttrs,
                    Selected: selected
                });
                mod.$productElementWrapper.append(html);
            });

            if (hideProducts) {
                // this.$productWrapperElement.addClass(CLASSNAME);
                this.$productWrapperElement.hide();
            } else {
                // this.$productWrapperElement.removeClass(CLASSNAME);
                this.$productWrapperElement.show();
            }
            this.$productElementWrapper.append($errorEl);
            this.$productElement = this.$element.find(PRODUCT_ELEMENT_SELECTOR);

            this.$productElement.change(function () {
                mod.$hiddenProductElement.val((0, _jquery2.default)(this).val()).trigger('change');
                (0, _jquery2.default)(document).trigger('product-selected');
            });

            if (!this.productSet) {
                mod.$hiddenProductElement.val('');
                mod.$hiddenProductElement.val(mod.selectedProduct).trigger('change');
                this.productSet = true;
            }
        }
    }, {
        key: 'loadCategories',
        value: function loadCategories() {
            var mod = this;
            mod.$hiddenElement.val('');
            var url = "/Umbraco/Api/GetProducts/GetCategories?selectedCategory=" + this.selectedCategory;
            _jquery2.default.ajax({
                url: url,
                method: 'get',
                success: function success(result) {
                    mod.SetCategoriesDropdown(result);
                },
                error: function error(e) {}
            }).done(function () {});
        }
    }, {
        key: 'loadSelectedCategory',
        value: function loadSelectedCategory() {
            var mod = this;
            var url = "/Umbraco/Api/GetProducts/GetCategoryByProduct?productId=" + this.selectedProduct;
            _jquery2.default.ajax({
                url: url,
                method: 'get',
                success: function success(result) {
                    mod.selectedCategory = result;
                    mod.loadCategories();
                },
                error: function error(e) {}
            }).done(function () {});
        }
    }, {
        key: 'loadProducts',
        value: function loadProducts() {
            var mod = this;
            var category = '';
            mod.$hiddenProductElement.val('');
            _jquery2.default.each(this.$categoryElement, function (i, v) {
                var $eleme = (0, _jquery2.default)(v);
                if ($eleme.is(':checked')) {
                    category = $eleme.val();
                }
            });

            var url = "/Umbraco/Api/GetProducts/GetProductsByCategory?category=" + category + '&selectedProduct=' + this.selectedProduct;
            _jquery2.default.ajax({
                url: url,
                method: 'get',
                success: function success(result) {
                    mod.SetProductsDropdown(result);
                },
                error: function error(e) {
                    mod.$productElementWrapper.addClass(CLASSNAME);
                }
            }).done(function () {});
        }
    }, {
        key: 'watch',
        value: function watch() {
            var mod = this;
            this.$categoryElement.on('change', function () {
                mod.loadProducts();
                var newvalue = (0, _jquery2.default)(this).val();
                mod.$hiddenElement.val(newvalue).trigger('change').focus().blur();
            });
            if (mod.selectedCategory.length > 0) {
                mod.$hiddenElement.val(mod.selectedCategory);
                mod.loadProducts();
            }
            if (mod.selectedProduct.length > 0) {
                mod.$hiddenProductElement.val('');
                mod.$hiddenProductElement.val(mod.selectedProduct).trigger('change');
                (0, _jquery2.default)(document).trigger('product-selected');
            }
        }
    }]);

    return CategoryAndProductSelector;
}();

CategoryAndProductSelector.DEFAULTS = {};

(0, _lib2.default)(PLUGIN_NAME, CategoryAndProductSelector);

(0, _jquery2.default)(document).ready(function () {
    (0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();

    //prevent multiple form submissions (SCF-317 - Duplicate quote entries)
    (0, _jquery2.default)('.getaquoteform > form').on('submit', function (e) {

        var $form = (0, _jquery2.default)('.getaquoteform > form');

        if ($form.data('submitted') === true) {
            e.preventDefault();
        } else {
            $form.validate();
            if ($form.valid()) {
                $form.data('submitted', true);
            }
        }
    });
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/increase-decrease.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-increase-decrease]';
var INCREASE_ELEMENT_SELECTOR = '[data-increase-decrease-increase]';
var DECREASE_ELEMENT_SELECTOR = '[data-increase-decrease-decrease]';
var INPUT_ELEMENT_SELECTOR = '[data-increase-decrease-input]';
var PLUGIN_NAME = 'increaseDecrease';

var IncreaseDecrease = function () {
    function IncreaseDecrease(element, options) {
        _classCallCheck(this, IncreaseDecrease);

        this.$element = (0, _jquery2.default)(element);
        this.$increase = this.$element.find(INCREASE_ELEMENT_SELECTOR);
        this.$decrease = this.$element.find(DECREASE_ELEMENT_SELECTOR);
        this.$input = this.$element.find(INPUT_ELEMENT_SELECTOR);
        this.watch();
    }

    _createClass(IncreaseDecrease, [{
        key: 'processInput',
        value: function processInput(increase) {
            var val = this.$input.val();
            var valInt = parseInt(val);
            if (valInt < 0 || isNaN(valInt) || val.length == 0) {
                valInt = 1;
            } else if (increase) {
                valInt = valInt + 1;
            } else if (valInt > 0) {
                valInt = valInt - 1;
            }

            this.$input.val(valInt);
        }
    }, {
        key: 'processInputVal',
        value: function processInputVal() {
            var val = this.$input.val();
            var valInt = parseInt(val);
            if (valInt < 0 || isNaN(valInt) || val.length == 0) {
                valInt = 1;
            }

            this.$input.val(valInt);
        }
    }, {
        key: 'watch',
        value: function watch() {
            var mod = this;
            this.$increase.on('click', function () {
                mod.processInput(true);
            });

            this.$decrease.on('click', function () {
                mod.processInput(false);
            });

            this.$input.on('change', function () {
                mod.processInputVal();
            });
        }
    }]);

    return IncreaseDecrease;
}();

IncreaseDecrease.DEFAULTS = {};
(0, _lib2.default)(PLUGIN_NAME, IncreaseDecrease);

(0, _jquery2.default)(document).ready(function () {
    (0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/jquery-validate-error-adjustments.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-umbraco-form]';
var PLUGIN_NAME = 'JqueryValidateErrorAdjustments';
var LAYOUT_ELEMENT_SELECTOR = '.field-layout__element';
var ERROR_LIST_SELECTOR = 'label.error';
var ELEMENT_CLASS_SELECTOR = '.field-input-option__input';
var INCREASE_DECREASE_ELEMENT_CLASS_SELECTOR = '.field-input-increase-decrease_input';
var ERROR_CLASS = 'error';

var JqueryValidateErrorAdjustments = function () {
    function JqueryValidateErrorAdjustments(element, options) {
        _classCallCheck(this, JqueryValidateErrorAdjustments);

        this.$element = (0, _jquery2.default)(element);
        this.form = element.querySelector('form');
        this.$submitButton = this.$element.find("[type=submit]").not(".cancel");
        this.$inputs = this.$element.find(ELEMENT_CLASS_SELECTOR);
        this.$increaseDecreaseInputs = this.$element.find(INCREASE_DECREASE_ELEMENT_CLASS_SELECTOR);
        this.processIncreaseDecreaseInputs();
        this.processInputs();
        this.watch();
    }

    _createClass(JqueryValidateErrorAdjustments, [{
        key: 'processIncreaseDecreaseInputs',
        value: function processIncreaseDecreaseInputs() {
            var mod = this;
            for (var i = 0; i < mod.$increaseDecreaseInputs.length; i++) {
                var el = mod.$increaseDecreaseInputs[i];
                var $el = (0, _jquery2.default)(el);
                var layoutElement = $el.closest(LAYOUT_ELEMENT_SELECTOR);
                if (layoutElement.length > 0) {
                    if ($el.hasClass(ERROR_CLASS)) {
                        var errorElement = (0, _jquery2.default)(layoutElement).find(ERROR_LIST_SELECTOR);
                        if (errorElement.length > 0) {
                            (0, _jquery2.default)(errorElement).detach().appendTo(layoutElement);
                        }
                    }
                }
            }
        }
    }, {
        key: 'processInputs',
        value: function processInputs() {
            var mod = this;
            for (var i = 0; i < mod.$inputs.length; i++) {
                var el = mod.$inputs[i];
                var $el = (0, _jquery2.default)(el);
                var layoutElement = $el.closest(LAYOUT_ELEMENT_SELECTOR);
                if (layoutElement.length > 0) {
                    if ($el.hasClass(ERROR_CLASS)) {
                        var errorElement = (0, _jquery2.default)(layoutElement).find(ERROR_LIST_SELECTOR);
                        if (errorElement.length > 0) {
                            (0, _jquery2.default)(errorElement).detach().appendTo(layoutElement);
                        }
                    }
                }
            }
        }
    }, {
        key: 'scrollToFirstError',
        value: function scrollToFirstError() {
            var errorElements = (0, _jquery2.default)(this.form).data('validator').errorList;

            console.log('errorElements', errorElements);
            if (errorElements.length > 0) {
                errorElements[0].element.focus();
            }
        }
    }, {
        key: 'watch',
        value: function watch() {
            var mod = this;
            this.$submitButton.click(function (evt) {
                mod.processIncreaseDecreaseInputs();
                mod.processInputs();
                mod.scrollToFirstError();
            });

            this.$increaseDecreaseInputs.change(function () {
                mod.processIncreaseDecreaseInputs();
            });
        }
    }]);

    return JqueryValidateErrorAdjustments;
}();

JqueryValidateErrorAdjustments.DEFAULTS = {};
(0, _lib2.default)(PLUGIN_NAME, JqueryValidateErrorAdjustments);

(0, _jquery2.default)(document).ready(function () {
    (0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/postcode-search.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

document.addEventListener("DOMContentLoaded", function () {
  var postcodeSearch = document.querySelectorAll("[data-postcode-search]");

  if (postcodeSearch.length > 0) {
    postcodeSearch.forEach(function (p) {

      // Function to fetch API results
      var fetchResults = function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(query, baseUrl, countryCode) {
          var response;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (query) {
                    _context.next = 3;
                    break;
                  }

                  dropdown.style.display = "none";
                  return _context.abrupt("return");

                case 3:
                  _context.prev = 3;
                  _context.next = 6;
                  return fetch(baseUrl + "/api/location/getPostCodes?countryCode=" + countryCode + "&search=" + query);

                case 6:
                  response = _context.sent;
                  _context.next = 9;
                  return response.json();

                case 9:
                  results = _context.sent;

                  if (results.length) {
                    _context.next = 14;
                    break;
                  }

                  dropdown.innerHTML = "<div>No results found</div>";
                  dropdown.style.display = "block";
                  return _context.abrupt("return");

                case 14:

                  renderDropdown();
                  _context.next = 20;
                  break;

                case 17:
                  _context.prev = 17;
                  _context.t0 = _context["catch"](3);

                  console.error("Error fetching results:", _context.t0);

                case 20:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[3, 17]]);
        }));

        return function fetchResults(_x, _x2, _x3) {
          return _ref.apply(this, arguments);
        };
      }();

      var results = [];
      var currentIndex = -1;
      var countryCode = p.dataset.countryCode ? p.dataset.countryCode : 'AU';
      var baseUrl = p.dataset.baseUrl;
      var input = p.querySelector("[data-postcode-search-input]");
      var dropdown = p.querySelector("[data-postcode-search-dropdown]");
      if (input && dropdown) {
        // Handle input event
        input.addEventListener("input", function () {
          fetchResults(this.value.trim(), baseUrl, countryCode);
        });

        // Handle keyboard navigation
        input.addEventListener("keydown", function (e) {
          var items = dropdown.querySelectorAll("div");

          if (e.key === "ArrowDown") {
            currentIndex = (currentIndex + 1) % items.length;
            updateActive(items);
          } else if (e.key === "ArrowUp") {
            currentIndex = (currentIndex - 1 + items.length) % items.length;
            updateActive(items);
          } else if (e.key === "Enter" && currentIndex > -1) {
            e.preventDefault();
            selectSuggestion(items[currentIndex]);
          }
        });

        // Handle click selection
        dropdown.addEventListener("click", function (e) {
          if (e.target.tagName === "DIV") {
            selectSuggestion(e.target);
          }
        });
      }

      // Hide dropdown when clicking outside
      document.addEventListener("click", function (e) {
        if (!e.target.closest(".postcode-search-container")) {
          dropdown.style.display = "none";
        }
      });

      function updateActive(items) {
        items.forEach(function (item, i) {
          item.classList.toggle("active", i === currentIndex);
          if (i === currentIndex) {
            item.scrollIntoView({ behavior: "smooth", block: "nearest" });
          }
        });
      }

      function selectSuggestion(selectedItem) {
        input.value = selectedItem.textContent.trim();
        dropdown.style.display = "none";
        $("[data-postcode-autopopulate] input").val(selectedItem.dataset.postcode);
      }

      function renderDropdown() {
        dropdown.innerHTML = results.map(function (item, index) {
          return "\n                        <div data-index=\"" + index + "\" data-id=\"" + item.id + "\" data-postcode=\"" + item.postcode + "\" class=\"" + (index === 0 ? "active" : "") + "\"> \n                            " + item.locality + ", " + item.state + " " + item.postcode + "\n                        </div>\n                    ";
        }).join("");

        dropdown.style.display = "block";
        currentIndex = 0;
      }
    });
  }
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/product-additional-features.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

var _strings = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/strings.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-product-category-additional-features]';
var PRODCUT_ELEMENT_SELECTOR = '[data-category-and-product-selector-product]';
var FEATURE_ELEMENT_SELECTOR = '[data-product-category-additional-features-wrapper]';
var ADDITIONAL_CONTENT_ELEMENT_SELECTOR = '[data-product-category-additional-features-additional-item-content]';
var TOGGLE_ELEMENT_SELECTOR = '[data-product-category-additional-features-toggle-element]';
var SELECTED_VALUES_ATTR = 'data-selected-values';
var ATTRIBUTES_ATTR = 'data-attributes';
var ELEMENT_ATTR = 'data-product-category-additional-features';
var ITEM_TEMPLATE_SELECTOR = '#productAdditionalFeaturesTemplate';
var CLASSNAME = "input-hidden";
var PLUGIN_NAME = 'ProductAdditionalFeatures';

var ProductAdditionalFeatures = function () {
    function ProductAdditionalFeatures(element, options) {
        _classCallCheck(this, ProductAdditionalFeatures);

        this.element = element;
        this.options = options;
        this.$element = (0, _jquery2.default)(element);
        this.$featuresElement = this.$element.find(FEATURE_ELEMENT_SELECTOR);
        this.$toggleElement = this.$element.find(TOGGLE_ELEMENT_SELECTOR);
        this.selectedVals = this.$element.attr(SELECTED_VALUES_ATTR);
        this.selectedValsList = typeof this.selectedVals !== 'undefined' && this.selectedVals.length > 0 ? JSON.parse(this.selectedVals) : new Array();
        this.attributes = this.$element.attr(ATTRIBUTES_ATTR);
        this.fieldId = this.$element.attr(ELEMENT_ATTR);
        this.itemTemplate = (0, _jquery2.default)(ITEM_TEMPLATE_SELECTOR).text();
        this.watch();
    }

    _createClass(ProductAdditionalFeatures, [{
        key: 'getSelectedProduct',
        value: function getSelectedProduct() {
            return this.$productElement.val();
        }
    }, {
        key: 'getAdditionalFeatures',
        value: function getAdditionalFeatures() {
            var mod = this;
            var url = "/Umbraco/Api/GetProducts/GetAdditionalFeatures";
            _jquery2.default.ajax({
                url: url,
                method: 'get',
                success: function success(result) {
                    mod.loadFeatures(result);
                },
                error: function error(e) {}
            }).done(function () {});
        }
    }, {
        key: 'getChecked',
        value: function getChecked(featureStr) {
            var selected = '';
            _jquery2.default.each(this.selectedValsList, function (k, selectedVal) {
                if (featureStr == selectedVal) {
                    selected = "checked=checked";
                }
            });

            return selected;
        }
    }, {
        key: 'loadFeatures',
        value: function loadFeatures(data) {
            var mod = this;
            var product = this.getSelectedProduct();
            var hideProducts = true;
            var $additionalContentElement = this.$featuresElement.find(ADDITIONAL_CONTENT_ELEMENT_SELECTOR);
            var $additionalContent = typeof $additionalContentElement !== 'undefined' ? $additionalContentElement.detach() : '';

            this.$featuresElement.empty();

            if (data.length > 0) {
                _jquery2.default.each(data, function (i, feature) {
                    if (feature.ProductId == product) {
                        _jquery2.default.each(feature.AdditionalFeatures, function (j, featureStr) {
                            hideProducts = false;

                            var selected = mod.getChecked(featureStr);
                            var id = mod.fieldId + '_' + j;
                            var html = (0, _strings.mustache)(mod.itemTemplate, {
                                Name: mod.fieldId,
                                Value: featureStr,
                                Id: id,
                                Attributes: mod.attributes,
                                Selected: selected
                            });

                            mod.$featuresElement.append(html);
                        });
                    }
                });

                if (typeof $additionalContent !== 'undefined' && $additionalContent.length > 0) {
                    mod.$featuresElement.append($additionalContent);
                }
            }

            this.toggleElementVisibility(hideProducts);
        }
    }, {
        key: 'toggleElementVisibility',
        value: function toggleElementVisibility(hide) {
            if (hide) {
                this.$element.addClass(CLASSNAME);
                this.$toggleElement.addClass(CLASSNAME);
            } else {
                this.$element.removeClass(CLASSNAME);
                this.$toggleElement.removeClass(CLASSNAME);
            }
        }
    }, {
        key: 'getCookie',
        value: function getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }
    }, {
        key: 'watch',
        value: function watch() {
            var mod = this;
            (0, _jquery2.default)(document).on('product-selected', function () {
                mod.$productElement = (0, _jquery2.default)(PRODCUT_ELEMENT_SELECTOR);
                mod.getAdditionalFeatures();
            });
        }
    }]);

    return ProductAdditionalFeatures;
}();

ProductAdditionalFeatures.DEFAULTS = {};

(0, _lib2.default)(PLUGIN_NAME, ProductAdditionalFeatures);

(0, _jquery2.default)(document).ready(function () {
    (0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/single-address-validation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = "[data-single-address-validation]";
var ELEMENT_SELECTOR_POSTCODE = "[data-postcode-autopopulate]";
var FORM_WRAPPER_SELECTOR = "data-form-wrapper-element";
var SINGLE_LINE_FIELD_SELECTOR = "data-single-line-field";
var SINGLE_LINE_FIELDS_SELECTOR = "data-single-line-fields";
var ADDRESS_LINE_0_SELECTOR = ".address-line-0";
var PLUGIN_NAME = "SingleAddressValidation";

var SingleAddressValidation = function () {
  function SingleAddressValidation(element, options) {
    _classCallCheck(this, SingleAddressValidation);

    this.element = element;
    this.options = options;
    this.$element = (0, _jquery2.default)(element);
    this.$parentEl = (0, _jquery2.default)(this.$element.attr(FORM_WRAPPER_SELECTOR));
    this.$addressLine0 = this.$parentEl.find(ADDRESS_LINE_0_SELECTOR);
    this.isSingleLine = typeof this.$element.attr(SINGLE_LINE_FIELD_SELECTOR) !== "undefined";
    this.singleLineFields = typeof this.$element.attr(SINGLE_LINE_FIELDS_SELECTOR) !== "undefined" ? this.$element.attr(SINGLE_LINE_FIELDS_SELECTOR) : "";

    this.watchGoogleMapApiError();
    this.init();
    this.preventSubmit();
  }

  _createClass(SingleAddressValidation, [{
    key: "watchGoogleMapApiError",
    value: function watchGoogleMapApiError() {
      var oldError = console.error;
      // Stops the input field from being disabled if issue with API
      var $element = this.$element;
      console.error = function (message) {
        if (message.toLowerCase().includes("google maps api error")) {
          $element.removeAttr("disabled");
          $element.attr("placeholder", "");
          $element.removeAttr("style", "");
          $element.parent().find(".field-validation-valid").hide();
        }

        oldError.apply(console, arguments);
      };
    }
  }, {
    key: "preventSubmit",
    value: function preventSubmit() {
      var _this = this;

      if (this.$element.closest("form").length) {
        this.$element.on("keydown", function (event) {
          //clear the hidden postcode field on keydown (forces the user to selected a suburb from the autocomplete list)
          (0, _jquery2.default)("[data-postcode-autopopulate] input").val("");

          if (event.keyCode === 13) {
            event.preventDefault();
            console.log("preventSubmit.keypress", event.keyCode);
          }
        });

        // Swap in the alternate submit value (e.g. the NZ-specific address shape) right
        // before the form actually submits, so the field can display one value while
        // sending a different one.
        this.$element.closest("form").on("submit", function () {
          var submitValue = _this.$element.data("submit-value");
          if (submitValue) {
            _this.$element.val(submitValue);
          }
        });
      }
    }
  }, {
    key: "init",
    value: function init() {
      var options = {
        types: ["address"],
        componentRestrictions: { country: this.options.countryCode }
      };

      var el = this.$element.attr("id");
      var thisElement = this.$element;
      window.autocompleteObj = new google.maps.places.Autocomplete(document.getElementById(el), options);

      this.autocomplete = window.autocompleteObj;
      this.autocomplete.addListener("place_changed", this.fillInPostcode.bind(this));

      var validator = this.$element.closest("form").validate();

      (0, _jquery2.default)("#" + el).rules("add", {
        validAddress: true
      });

      jQuery.validator.addMethod("validAddress", function (value, element) {
        if ((0, _jquery2.default)("div[data-postcode-autopopulate] input").val().length <= 0) {
          return false;
        } else {
          return true;
        }
      }, "Please enter a valid address");
    }
  }, {
    key: "fillInPostcode",
    value: function fillInPostcode() {
      var inputElement = this.$element;
      var isNZ = /^nz/i.test(this.options.countryCode || "");

      //Retrieve postcode from lat/lng and populate the postcode form field
      var place = this.autocomplete.getPlace();

      /*console.log('place');
      console.log(place);
      console.log(place.geometry.location.lat());
      console.log(place.geometry.location.lng());*/

      var latlng = new google.maps.LatLng(place.geometry.location.lat(), place.geometry.location.lng());
      var geocoder = new google.maps.Geocoder();

      geocoder.geocode({ latLng: latlng }, function (results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          console.log(status);
        }
        // This is checking to see if the Geoeode Status is OK before proceeding
        if (status == google.maps.GeocoderStatus.OK) {
          //console.log('geocoder');
          //console.log(results);

          var address = results[0].formatted_address;

          var searchAddressComponents = results[0].address_components,
              searchPostalCode = "",
              searchSuburb = "",
              searchLocality = "",
              searchAdminAreaLevel1 = "",
              searchStreetNumber = "",
              searchRoute = "";

          //console.log('searchAddressComponents');
          //console.log(searchAddressComponents);
          var suburbLocator = "locality";

          if (!searchAddressComponents.some(function (c) {
            return c.types[0] === "locality";
          })) {
            suburbLocator = "administrative_area_level_1"; //some of the NZ cities don't have locality level component, use administrative_area_level_1 instead. e.g. Auckland
          }

          _jquery2.default.each(searchAddressComponents, function () {
            var _this2 = this;

            if (this.types[0] === "postal_code") {
              searchPostalCode = this.short_name;
            }
            if (this.types[0] === suburbLocator) {
              searchSuburb = this.short_name;
            }
            if (this.types[0] === "locality") {
              searchLocality = this.short_name;
            }
            if (this.types[0] === "administrative_area_level_1") {
              searchAdminAreaLevel1 = this.short_name;
            }
            if (this.types[0] === "street_number") {
              searchStreetNumber = this.short_name;
            }
            if (this.types[0] === "route") {
              searchRoute = this.short_name;
            }
            // remove country name from full address value
            if (this.types[0] === "country" && address) {
              address = address.split(", ").filter(function (a) {
                return a !== _this2.long_name;
              }).join(", ");
            }
          });

          var submitAddress = address;
          if (isNZ) {
            // Form a "street, locality, admin area level 1 postcode" shape
            // so the server's comma-based address parsing works reliably for NZ addresses.
            // Displayed value stays the same as Google's formatted address; this
            // alternate value is swapped in only at submit time - see preventSubmit().
            var streetPart = [searchStreetNumber, searchRoute].filter(function (p) {
              return p;
            }).join(" ");
            var stateAndPostcodePart = [searchAdminAreaLevel1, searchPostalCode].filter(function (p) {
              return p;
            }).join(" ");
            submitAddress = [streetPart, searchLocality, stateAndPostcodePart].filter(function (p) {
              return p;
            }).join(", ");
          }

          (0, _jquery2.default)("[data-postcode-autopopulate] input").val(searchPostalCode);
          (0, _jquery2.default)("[data-suburb-postcode-noaddress-autosuggest] input").val(searchSuburb);

          if (address) {
            (0, _jquery2.default)("[data-single-line-address-autosuggest] input").val(address).data("submit-value", submitAddress);
          }

          // validate the suburb input
          (0, _jquery2.default)(inputElement).valid();
        }
      });

      (0, _jquery2.default)(document).trigger("address-validation-complete");
    }
  }]);

  return SingleAddressValidation;
}();

SingleAddressValidation.DEFAULTS = {
  countryCode: (0, _jquery2.default)("meta[name=\"site.countryCode\"]").attr("content")
};

(0, _lib2.default)(PLUGIN_NAME, SingleAddressValidation);

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/single-line-address-autosuggest.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = "[data-single-line-address-autosuggest]";
var PLUGIN_NAME = "SingleLineAddressAutoSuggest";
var INPUT_SELECTOR = "[data-suburb-validation]";
var POSTCODE_ELEMENT_SELECTOR = "[data-suburb-postcode-autosuggest-postcode]";
var POSTCODE_INPUT_ELEMENT_SELECTOR = ".postal_code";

var SingleLineAddressAutoSuggest = function () {
  function SingleLineAddressAutoSuggest(element, options) {
    _classCallCheck(this, SingleLineAddressAutoSuggest);

    this.$element = (0, _jquery2.default)(element);
    this.$input = this.$element.find(INPUT_SELECTOR);
    this.$postcode = this.$element.find(POSTCODE_ELEMENT_SELECTOR);
    this.$postcodeInput = this.$postcode.find(POSTCODE_INPUT_ELEMENT_SELECTOR);

    /*if (this.$input.val().length > 0) {
            this.validate();
        }
        this.watch();*/
  }

  _createClass(SingleLineAddressAutoSuggest, [{
    key: "postcodeIsValid",
    value: function postcodeIsValid(postcode) {
      var pcode = parseInt(postcode);
      if (isNaN(pcode)) {
        return false;
      }
      return pcode >= 1000 && pcode <= 1999 || pcode >= 2000 && pcode <= 2599 || pcode >= 2619 && pcode <= 2899 || pcode >= 2921 && pcode <= 2999 || pcode >= 200 && pcode <= 299 || pcode >= 2600 && pcode <= 2618 || pcode >= 2900 && pcode <= 2920 || pcode >= 3000 && pcode <= 3999 || pcode >= 8000 && pcode <= 8999 || pcode >= 4000 && pcode <= 4999 || pcode >= 9000 && pcode <= 9999 || pcode >= 5000 && pcode <= 5999 || pcode >= 6000 && pcode <= 6799 || pcode >= 6800 && pcode <= 6999 || pcode >= 7000 && pcode <= 7999 || pcode >= 800 && pcode <= 999;
    }
  }, {
    key: "validate",
    value: function validate() {
      if (this.$postcodeInput.val().length > 0 && this.postcodeIsValid(this.$postcodeInput.val())) {
        this.$postcode.hide();
        return true;
      } else {
        this.$postcode.show();
        return false;
      }
    }
  }, {
    key: "watch",
    value: function watch() {
      var mod = this;

      this.$input.on("change", function () {
        mod.validate();
      });
    }
  }]);

  return SingleLineAddressAutoSuggest;
}();

SingleLineAddressAutoSuggest.DEFAULTS = {};
(0, _lib2.default)(PLUGIN_NAME, SingleLineAddressAutoSuggest);

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/suburb-postcode-autosuggest.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-suburb-postcode-autosuggest]';
var PLUGIN_NAME = 'SuburbPostcodeAutoSuggest';
var INPUT_SELECTOR = '[data-address-validation]';
var POSTCODE_ELEMENT_SELECTOR = '[data-suburb-postcode-autosuggest-postcode]';
var POSTCODE_INPUT_ELEMENT_SELECTOR = '.postal_code';

var SuburbPostcodeAutoSuggest = function () {
    function SuburbPostcodeAutoSuggest(element, options) {
        _classCallCheck(this, SuburbPostcodeAutoSuggest);

        this.$element = (0, _jquery2.default)(element);
        this.$input = this.$element.find(INPUT_SELECTOR);
        this.$postcode = this.$element.find(POSTCODE_ELEMENT_SELECTOR);
        this.$postcodeInput = this.$postcode.find(POSTCODE_INPUT_ELEMENT_SELECTOR);

        if (this.$input.val().length > 0) {
            this.validate();
        }
        this.watch();
    }

    _createClass(SuburbPostcodeAutoSuggest, [{
        key: 'postcodeIsValid',
        value: function postcodeIsValid(postcode) {
            var pcode = parseInt(postcode);
            if (isNaN(pcode)) {
                return false;
            }
            return pcode >= 1000 && pcode <= 1999 || pcode >= 2000 && pcode <= 2599 || pcode >= 2619 && pcode <= 2899 || pcode >= 2921 && pcode <= 2999 || pcode >= 200 && pcode <= 299 || pcode >= 2600 && pcode <= 2618 || pcode >= 2900 && pcode <= 2920 || pcode >= 3000 && pcode <= 3999 || pcode >= 8000 && pcode <= 8999 || pcode >= 4000 && pcode <= 4999 || pcode >= 9000 && pcode <= 9999 || pcode >= 5000 && pcode <= 5999 || pcode >= 6000 && pcode <= 6799 || pcode >= 6800 && pcode <= 6999 || pcode >= 7000 && pcode <= 7999 || pcode >= 800 && pcode <= 999;
        }
    }, {
        key: 'validate',
        value: function validate() {
            if (this.$postcodeInput.val().length > 0 && this.postcodeIsValid(this.$postcodeInput.val())) {
                this.$postcode.hide();
                return true;
            } else {
                this.$postcode.show();
                return false;
            }
        }
    }, {
        key: 'watch',
        value: function watch() {
            var mod = this;

            this.$input.on('change', function () {
                mod.validate();
            });
        }
    }]);

    return SuburbPostcodeAutoSuggest;
}();

SuburbPostcodeAutoSuggest.DEFAULTS = {};
(0, _lib2.default)(PLUGIN_NAME, SuburbPostcodeAutoSuggest);

(0, _jquery2.default)(document).ready(function () {
    (0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/suburb-postcode-noaddress-autosuggest.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-suburb-postcode-noaddress-autosuggest]';
var PLUGIN_NAME = 'SuburbPostcodeNoAddressAutoSuggest';
var INPUT_SELECTOR = '[data-suburb-validation]';
var POSTCODE_ELEMENT_SELECTOR = '[data-suburb-postcode-autosuggest-postcode]';
var POSTCODE_INPUT_ELEMENT_SELECTOR = '.postal_code';

var SuburbPostcodeNoAddressAutoSuggest = function () {
    function SuburbPostcodeNoAddressAutoSuggest(element, options) {
        _classCallCheck(this, SuburbPostcodeNoAddressAutoSuggest);

        this.$element = (0, _jquery2.default)(element);
        this.$input = this.$element.find(INPUT_SELECTOR);
        this.$postcode = this.$element.find(POSTCODE_ELEMENT_SELECTOR);
        this.$postcodeInput = this.$postcode.find(POSTCODE_INPUT_ELEMENT_SELECTOR);

        /*if (this.$input.val().length > 0) {
            this.validate();
        }
        this.watch();*/
    }

    _createClass(SuburbPostcodeNoAddressAutoSuggest, [{
        key: 'postcodeIsValid',
        value: function postcodeIsValid(postcode) {
            var pcode = parseInt(postcode);
            if (isNaN(pcode)) {
                return false;
            }
            return pcode >= 1000 && pcode <= 1999 || pcode >= 2000 && pcode <= 2599 || pcode >= 2619 && pcode <= 2899 || pcode >= 2921 && pcode <= 2999 || pcode >= 200 && pcode <= 299 || pcode >= 2600 && pcode <= 2618 || pcode >= 2900 && pcode <= 2920 || pcode >= 3000 && pcode <= 3999 || pcode >= 8000 && pcode <= 8999 || pcode >= 4000 && pcode <= 4999 || pcode >= 9000 && pcode <= 9999 || pcode >= 5000 && pcode <= 5999 || pcode >= 6000 && pcode <= 6799 || pcode >= 6800 && pcode <= 6999 || pcode >= 7000 && pcode <= 7999 || pcode >= 800 && pcode <= 999;
        }
    }, {
        key: 'validate',
        value: function validate() {
            if (this.$postcodeInput.val().length > 0 && this.postcodeIsValid(this.$postcodeInput.val())) {
                this.$postcode.hide();
                return true;
            } else {
                this.$postcode.show();
                return false;
            }
        }
    }, {
        key: 'watch',
        value: function watch() {
            var mod = this;

            this.$input.on('change', function () {
                mod.validate();
            });
        }
    }]);

    return SuburbPostcodeNoAddressAutoSuggest;
}();

SuburbPostcodeNoAddressAutoSuggest.DEFAULTS = {};
(0, _lib2.default)(PLUGIN_NAME, SuburbPostcodeNoAddressAutoSuggest);

(0, _jquery2.default)(document).ready(function () {
    (0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/suburb-validation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = "[data-suburb-validation]";
var ELEMENT_SELECTOR_POSTCODE = "[data-postcode-autopopulate]";
var FORM_WRAPPER_SELECTOR = "data-form-wrapper-element";
var SINGLE_LINE_FIELD_SELECTOR = "data-single-line-field";
var SINGLE_LINE_FIELDS_SELECTOR = "data-single-line-fields";
var ADDRESS_LINE_0_SELECTOR = ".address-line-0";
var PLUGIN_NAME = "suburbValidation";
var MODULE_NAME = "app.core/modules/suburb-validation";

var SuburbValidation = function () {
  function SuburbValidation(element, options) {
    _classCallCheck(this, SuburbValidation);

    this.element = element;
    this.options = options;
    this.$element = (0, _jquery2.default)(element);
    this.$parentEl = (0, _jquery2.default)(this.$element.attr(FORM_WRAPPER_SELECTOR));
    this.$addressLine0 = this.$parentEl.find(ADDRESS_LINE_0_SELECTOR);
    this.isSingleLine = typeof this.$element.attr(SINGLE_LINE_FIELD_SELECTOR) !== "undefined";
    this.singleLineFields = typeof this.$element.attr(SINGLE_LINE_FIELDS_SELECTOR) !== "undefined" ? this.$element.attr(SINGLE_LINE_FIELDS_SELECTOR) : "";

    this.watchGoogleMapApiError();
    this.init();
    this.preventSubmit();
  }

  _createClass(SuburbValidation, [{
    key: "watchGoogleMapApiError",
    value: function watchGoogleMapApiError() {
      var oldError = console.error;
      // Stops the input field from being disabled if issue with API
      var $element = this.$element;
      console.error = function (message) {
        if (message.toLowerCase().includes("google maps api error")) {
          $element.removeAttr("disabled");
          $element.attr("placeholder", "");
          $element.removeAttr("style", "");
          $element.parent().find(".field-validation-valid").hide();
        }

        oldError.apply(console, arguments);
      };
    }
  }, {
    key: "preventSubmit",
    value: function preventSubmit() {
      if (this.$element.closest("form").length) {
        this.$element.on("keydown", function (event) {
          //clear the hidden postcode field on keydown (forces the user to selected a suburb from the autocomplete list)
          (0, _jquery2.default)("[data-postcode-autopopulate] input").val("");

          if (event.keyCode === 13) {
            event.preventDefault();
            console.log("preventSubmit.keypress", event.keyCode);
          }
        });
      }
    }
  }, {
    key: "init",
    value: function init() {
      var options = {
        types: ["(cities)"],
        componentRestrictions: { country: this.options.countryCode }
      };

      var el = this.$element.attr("id");
      var thisElement = this.$element;
      window.autocompleteObj = new google.maps.places.Autocomplete(document.getElementById(el), options);

      this.autocomplete = window.autocompleteObj;
      this.autocomplete.addListener("place_changed", this.fillInPostcode.bind(this));

      var validator = this.$element.closest("form").validate();

      (0, _jquery2.default)("#" + el).rules("add", {
        validSuburb: true
      });

      jQuery.validator.addMethod("validSuburb", function (value, element) {
        if ((0, _jquery2.default)("div[data-postcode-autopopulate] input").val().length <= 0) {
          return false;
        } else {
          return true;
        }
      }, "Please enter a valid suburb");
    }
  }, {
    key: "fillInPostcode",
    value: function fillInPostcode() {
      var inputElement = this.$element;

      //Retrieve postcode from lat/lng and populate the postcode form field
      var place = this.autocomplete.getPlace();

      /*console.log('place');
      console.log(place);
      console.log(place.geometry.location.lat());
      console.log(place.geometry.location.lng());*/

      var latlng = new google.maps.LatLng(place.geometry.location.lat(), place.geometry.location.lng());
      var geocoder = new google.maps.Geocoder();

      geocoder.geocode({ latLng: latlng }, function (results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          console.log(status);
        }
        // This is checking to see if the Geoeode Status is OK before proceeding
        if (status == google.maps.GeocoderStatus.OK) {
          //console.log('geocoder');
          //console.log(results);

          var address = results[0].formatted_address;

          var searchAddressComponents = results[0].address_components,
              searchPostalCode = "",
              searchSuburb = "";

          //console.log('searchAddressComponents');
          //console.log(searchAddressComponents);
          var suburbLocator = "locality";

          if (!searchAddressComponents.some(function (c) {
            return c.types[0] === "locality";
          })) {
            suburbLocator = "administrative_area_level_1"; //some of the NZ cities don't have locality level component, use administrative_area_level_1 instead. e.g. Auckland
          }

          _jquery2.default.each(searchAddressComponents, function () {
            if (this.types[0] === "postal_code") {
              searchPostalCode = this.short_name;
            }
            if (this.types[0] === suburbLocator) {
              searchSuburb = this.short_name;
            }
          });

          (0, _jquery2.default)("[data-postcode-autopopulate] input").val(searchPostalCode);
          (0, _jquery2.default)("[data-suburb-postcode-noaddress-autosuggest] input").val(searchSuburb);

          // validate the suburb input
          (0, _jquery2.default)(inputElement).valid();
        }
      });

      (0, _jquery2.default)(document).trigger("address-validation-complete");
    }
  }]);

  return SuburbValidation;
}();

SuburbValidation.DEFAULTS = {
  countryCode: (0, _jquery2.default)("meta[name=\"site.countryCode\"]").attr("content")
};

(0, _lib2.default)(PLUGIN_NAME, SuburbValidation);

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/tooltip.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-tool-tip]';
var PLUGIN_NAME = 'toolTip';
var TIP_ACTIVE_CLASSNAME = 'active';

var ToolTip = function () {
    function ToolTip(element, options) {
        _classCallCheck(this, ToolTip);

        this.$element = (0, _jquery2.default)(element);
        this.watch();
    }

    _createClass(ToolTip, [{
        key: 'watch',
        value: function watch() {
            var mod = this;
            this.$element.on('click', function () {
                if (mod.$element.hasClass(TIP_ACTIVE_CLASSNAME)) {
                    mod.$element.removeClass(TIP_ACTIVE_CLASSNAME);
                } else {
                    mod.$element.addClass(TIP_ACTIVE_CLASSNAME);
                }
            });
        }
    }]);

    return ToolTip;
}();

ToolTip.DEFAULTS = {};
(0, _lib2.default)(PLUGIN_NAME, ToolTip);

(0, _jquery2.default)(document).ready(function () {
    (0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/site-header/alert/site-alert.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/site-header/navigation--obscurable.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/jquery-validate-error-adjustments.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/category-and-product-selector.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/single-address-validation.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/single-line-address-autosuggest.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/tooltip.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/increase-decrease.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/address-validation.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/suburb-validation.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/suburb-postcode-autosuggest.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/suburb-postcode-noaddress-autosuggest.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/product-additional-features.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/forms/postcode-search.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/modal/index.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/sticky-navigation/index.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/buttons/analytics-trigger.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/dropdown/index.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/banner-scroll/index.js");

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/modal/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Modaal is not a spelling error!
// It is the name of the 3rd party modal component we are using
var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-modal]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'modal';

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("component--modal").then(__webpack_require__.bind(null, "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/modal/modal.js")).then(function () {
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/site-header/alert/site-alert.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

var _debug = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)('core/components/site-header/alert');

var ELEMENT_SELECTOR = "[data-site-alert]";

var SiteAlert = function () {
	function SiteAlert(element, options) {
		_classCallCheck(this, SiteAlert);

		this.element = element;
		this.options = options;

		this.dismissButton = document.querySelector(this.options.dismissButtonSelector);

		this.watch();
	}

	_createClass(SiteAlert, [{
		key: "watch",
		value: function watch() {
			this.dismissButton.addEventListener("click", this.dismiss.bind(this));
		}
	}, {
		key: "dismiss",
		value: function dismiss() {
			(0, _jquery2.default)(this.element).remove();
			_jquery2.default.get(this.options.cookieEndpoint, function (data) {
				log(data);
			});
		}
	}]);

	return SiteAlert;
}();

SiteAlert.DEFAULTS = {};

(0, _lib2.default)("siteAlert", SiteAlert);

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR)["siteAlert"]();
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/site-header/navigation--obscurable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Obscurable Navigation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @original-idea Kate York
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @original-idea Oliver Boermans
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author Zenobius Jiricek
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * see ./header.scss
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

//
// Utilities


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

var _selectors = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PLUGIN_NAME = "NavigationObscurable";
var ELEMENT_SELECTOR = "[data-navigation-obscurable]";
var log = (0, _debug2.default)("core/components/site-header/navigation--obscurable");

var ObscurableNavigationPlugin = function () {
	function ObscurableNavigationPlugin(element) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		_classCallCheck(this, ObscurableNavigationPlugin);

		this.element = element;
		this.$element = (0, _jquery2.default)(element);
		this.options = options;
		this.options.tolerancePx = parseInt(this.options.tolerancePx);
		this.options.minExposed = parseInt(this.options.minExposed);

		log("created", { element: element, options: this.options });
		this.components = {
			obscuredItemContainer: (0, _selectors.selectTarget)(this.options.obscuredItemContainerSelector, this.$element),
			visibleItemContainer: (0, _selectors.selectTarget)(this.options.visibleItemContainerSelector, this.$element),
			additionalItemsContainer: (0, _jquery2.default)(this.options.additionalItemsSelector),
			logo: (0, _jquery2.default)(this.options.logoSelector),
			outsideAdditionalItemContainerSelector: (0, _jquery2.default)(this.options.outsideAdditionalItemContainerSelector),
			obscuredItemContainerToggle: (0, _selectors.selectTarget)(this.options.obscuredItemContainerToggleSelector, this.$element),
			burgerButton: (0, _jquery2.default)(this.options.burgerButtonSelector)
		};

		this.watch();
	}

	_createClass(ObscurableNavigationPlugin, [{
		key: "watch",
		value: function watch() {
			var _this = this;

			log("watch");
			this.currentTestId = 0;
			(0, _jquery2.default)(window).resize(function () {
				_this.components.visibleItemContainer.addClass("testing");
			});
			(0, _jquery2.default)(window).resize(this.fn.debounce(this.test.bind(this), this.options.testTimeoutMs, true));
			(0, _jquery2.default)(window).resize(this.fn.debounce(this.test.bind(this), this.options.testTimeoutMs));
			setTimeout(this.test.bind(this), this.options.testTimeoutMs);
		}
	}, {
		key: "test",
		value: function test() {
			log("test");
			this.unObscureItems();
			this.testItems();
		}
	}, {
		key: "isItemObscured",
		value: function isItemObscured(element) {
			log("isItemObscured", element);
			var $testElement = (0, _jquery2.default)(element);
			var width = $testElement.outerWidth(true);
			var rightEdgePosition = width + this.options.tolerancePx + this.accumulatedWidth;
			var result = rightEdgePosition > this.actualContainerWidth;
			log("isItemObscured", rightEdgePosition, this.actualContainerWidth, result);
			this.accumulatedWidth += width;
			return result;
		}
	}, {
		key: "unObscureItems",
		value: function unObscureItems() {
			var _this2 = this;

			log("unObscureItems");
			// Put everything back in main nav
			// to prepare for testing if they in fact fit.
			(0, _selectors.selectTarget)(this.options.intersectingItemSelector, this.components.obscuredItemContainer).removeClass(this.options.obscuredItemClasses).addClass(this.options.visibleItemClasses).each(function (index, element) {
				_this2.components.visibleItemContainer.append((0, _jquery2.default)(element).detach());
			});

			(0, _selectors.selectTarget)(this.options.additionalItemSelector, this.components.obscuredItemContainer).removeClass(this.options.obscuredItemClasses).addClass(this.options.visibleItemClasses).each(function (index, element) {
				_this2.components.additionalItemsContainer.append((0, _jquery2.default)(element).detach());
			});

			(0, _selectors.selectTarget)(this.options.outsideAdditionalItemSelector, this.components.outsideAdditionalItemContainerSelector).removeClass(this.options.obscuredItemClasses).addClass(this.options.visibleItemClasses).each(function (index, element) {
				_this2.components.additionalItemsContainer.append((0, _jquery2.default)(element).detach());
			});
		}
	}, {
		key: "moveItem",
		value: function moveItem(element) {
			log("moveItem", element);
			var $element = (0, _jquery2.default)(element).detach();

			$element.addClass(this.options.obscuredItemClasses).removeClass(this.options.visibleItemClasses);

			this.components.obscuredItemContainer.append($element);

			$element.show();
		}
	}, {
		key: "moveOutsideItem",
		value: function moveOutsideItem(element) {
			log("moveOutsideItem", element);
			var $element = (0, _jquery2.default)(element).detach();

			$element.addClass(this.options.obscuredItemClasses).removeClass(this.options.visibleItemClasses);

			this.components.outsideAdditionalItemContainerSelector.append($element);

			$element.show();
		}
	}, {
		key: "obscureRemaining",
		value: function obscureRemaining(items) {
			var _this3 = this;

			log('obscureAll');
			// make burger button visible
			if (this.components.burgerButton.length && this.options.showBurgerClass) {
				this.components.burgerButton.addClass(this.options.showBurgerClass);
			}

			// obscure all items
			items.each(function (index, element) {
				return _this3.moveItem(element);
			});
		}
	}, {
		key: "unobscureRemaining",
		value: function unobscureRemaining() {
			// hide burger button
			if (this.components.burgerButton.length && this.options.showBurgerClass) {
				this.components.burgerButton.removeClass(this.options.showBurgerClass);
			}
		}
	}, {
		key: "testItems",
		value: function testItems() {
			var _this4 = this;

			log("testItems");
			var toggleWidth = this.components.obscuredItemContainerToggle.innerWidth();
			this.components.obscuredItemContainerToggle.detach();

			this.unobscureRemaining();

			// Move the items that don't fit back to mobile nav
			this.components.obscuredItemContainerToggle.show().removeClass(this.options.obscuredItemContainerToggleInvisibleClass);
			var $items = (0, _selectors.selectTarget)(this.options.intersectingItemSelector, this.components.visibleItemContainer);
			var $additionalItems = (0, _selectors.selectTarget)(this.options.additionalItemSelector, this.components.additionalItemsContainer);
			var $additionalOutsideItems = (0, _selectors.selectTarget)(this.options.outsideAdditionalItemSelector, this.components.additionalItemsContainer);

			log("testItems.items", $items);

			this.actualContainerWidth = this.components.visibleItemContainer.innerWidth();
			// build a list of items that don't fit
			this.accumulatedWidth = 0;
			var obscuredItems = $items.filter(function (index, element) {
				return _this4.isItemObscured(element);
			});
			log("testItems.obscuredItems", obscuredItems);

			// if at least one item doesn't fit
			if (!this.components.visibleItemContainer.is(":visible")) {
				$items.each(function (index, element) {
					return _this4.moveItem(element);
				});
			} else if (obscuredItems.length > 0) {
				// reduce width of container
				this.actualContainerWidth = this.actualContainerWidth - toggleWidth;
				log("testItems.atLeatOneObscured", this.actualContainerWidth);

				this.accumulatedWidth = 0;
				obscuredItems = $items
				// re-test visible items based on new container width
				.filter(function (index, element) {
					return _this4.isItemObscured(element);
				})
				// then move them
				.each(function (index, element) {
					return _this4.moveItem(element);
				});
			}

			// Move additional based on being visible
			if (!this.components.additionalItemsContainer.is(":visible")) {
				$additionalItems.each(function (index, element) {
					return _this4.moveItem(element);
				});
				$additionalOutsideItems.each(function (index, element) {
					return _this4.moveOutsideItem(element);
				});
			}

			if (obscuredItems.length > 0 || obscuredItems.length == $items.length) {
				this.components.visibleItemContainer.append(this.components.obscuredItemContainerToggle);
				this.components.logo.removeClass(this.options.logoAdjustmentClass);
			}

			if (!this.components.obscuredItemContainer.children().length > 0) {
				this.components.obscuredItemContainerToggle.hide();
				this.components.logo.addClass(this.options.logoAdjustmentClass);
			}

			if ($items.length - obscuredItems.length < this.options.minExposed) {
				log('Not enough elements shown - hide them all');
				this.components.obscuredItemContainerToggle.addClass(this.options.obscuredItemContainerToggleInvisibleClass);
				this.obscureRemaining($items);
			} else {
				log('Only a few items hidden, this is okay');
			}

			this.components.visibleItemContainer.removeClass("testing");
		}
	}]);

	return ObscurableNavigationPlugin;
}();

ObscurableNavigationPlugin.DEFAULTS = {
	tolerancePx: 40,
	testTimeoutMs: 150,
	reflowOnResize: true,
	visibleItemClasses: "navigation__item--unobscured",
	obscuredItemClasses: "navigation__item--obscured",
	visibleItemContainerSelector: "(children) [data-navigation--visible-items]",
	intersectingItemSelector: "(children) [data-navigation--intersecting-item]",
	additionalItemSelector: "(children) [data-navigation--additional-item]",
	obscuredItemContainerSelector: "(children) [data-navigation--obscured-items]",
	obscuredItemContainerToggleSelector: "(children) [data-navigation--obscured-items-toggle]",
	obscuredItemContainerToggleInvisibleClass: 'navigation__item--invisible',
	additionalItemsSelector: "[data-navigation-additional-items]",
	outsideAdditionalItemSelector: "(children) [data-navigation--additional-outside-item]",
	outsideAdditionalItemContainerSelector: "[data-header-controller]",
	logoAdjustmentClass: "navigation__logo-image--overlap-30-years",
	logoSelector: "[data-navigation-logo]",
	minExposed: 0
};

(0, _lib2.default)(PLUGIN_NAME, ObscurableNavigationPlugin);

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/sticky-navigation/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PLUGIN_NAME = 'stickyNavigation';
/**
 * Sticky Navigation
 */

var StickyNavigation = function () {
    function StickyNavigation(element) {
        _classCallCheck(this, StickyNavigation);

        this.element = element;
        this.$element = (0, _jquery2.default)(element);
        this.$viewportElement = (0, _jquery2.default)('[data-sticky-nav-viewport-element]');
        this.executeFunction;
        this.timeToExecute = 200;

        this.watch();
    }

    _createClass(StickyNavigation, [{
        key: 'onScroll',
        value: function onScroll() {
            clearTimeout(this.executeFunction);
            var plug = this;
            this.executeFunction = setTimeout(function () {
                if (plug.$viewportElement.length > 0) {
                    var viewportElementVisible = true;
                    var offsetTop = (0, _jquery2.default)(window).scrollTop();
                    var viewportElementOffsetTop = plug.$viewportElement.offset().top;
                    plug.$element.removeClass('active');
                    if (!plug.isElementInViewport() && offsetTop > viewportElementOffsetTop) {
                        viewportElementVisible = false;
                    }

                    if (!viewportElementVisible) {
                        plug.$element.addClass('active');
                    }
                }
            }, this.timeToExecute);
        }
    }, {
        key: 'isElementInViewport',
        value: function isElementInViewport() {
            var el = this.$viewportElement;

            //special bonus for those using jQuery
            el = el[0];
            var rect = el.getBoundingClientRect();
            return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
            rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
            ;
        }
    }, {
        key: 'watch',
        value: function watch() {
            (0, _jquery2.default)(window).on('scroll', this.onScroll.bind(this));
        }
    }, {
        key: 'unwatch',
        value: function unwatch() {
            (0, _jquery2.default)(window).off('scroll', this.onScroll.bind(this));
            log('unbound', this.$element);
        }
    }]);

    return StickyNavigation;
}();

(0, _lib2.default)(PLUGIN_NAME, StickyNavigation);

(0, _jquery2.default)(document).ready(function () {
    (0, _jquery2.default)(".sticky-navigation").stickyNavigation();
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/index.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/components/index.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/client/src/core/vendor/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('fusion-core');

(0, _jquery2.default)(function () {
	log('ready');
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__collapsible/plugin--bundled.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__toggle-element-classes/index.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__remove-element-classes/index.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__add-element-classes/index.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__focus-within/index.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__focus/index.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__emit-on-dirty/index.js");

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__trigger-event/index.js");

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__add-element-classes/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-add-element-classes]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'AddElementClasses';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--add-element-classes").then(__webpack_require__.bind(null, "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__add-element-classes/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__collapsible/collapsible.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getJSONValue(stringValue) {
	try {
		return JSON.parse(stringValue);
	} catch (error) {
		return stringValue;
	}
}

var Collapsible = function () {
	function Collapsible(element, options) {
		_classCallCheck(this, Collapsible);

		this.element = element;
		this.options = options;

		var scopes = {
			document: document,
			element: this.element
		};

		//	Look for the content element within this element or elsewhere
		var contentSelectorIsId = this.options.contentSelector && this.options.contentSelector[0] === "#";

		if (contentSelectorIsId) {
			this.contentSelectorScope = scopes["document"];
		} else {
			this.contentSelectorScope = scopes[this.options.contentSelectorScope] ? scopes[this.options.contentSelectorScope] : scopes["element"];
		}

		// if no button is specified perhaps this is the button
		this.button = this.options.buttonSelector ? this.element.querySelector(this.options.buttonSelector) : this.element;

		// Content is optional
		//	we may be toggling with CSS based on aria-expanded button attr
		this.content = this.options.contentSelector && this.contentSelectorScope.querySelector(this.options.contentSelector);
		this.collapseWith = this.options.collapsedClass ? "class" : "hidden";
		this.collapsedClass = this.options.collapsedClass;

		this.toggleMethod = this.collapseWith === "class" ? this.toggleWithClass : this.toggleWithHidden;

		this.attributeObserver = new MutationObserver(this.onAttributeChange.bind(this));

		this.bindDocumentEvents = this.options.closeWithDocumentClick ? this.bindDocumentClick : function () {};

		this.unbindDocumentEvents = this.options.closeWithDocumentClick ? this.unbindDocumentClick : function () {};

		this.init();
		this.watch();
	}

	_createClass(Collapsible, [{
		key: "init",
		value: function init() {
			// component enabled - show the button
			this.button.hidden = false;

			// Determine initial collapse state
			//	if set open option determines init state
			var doCollapse = this.options.open !== undefined ? !this.options.open : true;

			this.toggleMethod(doCollapse);
			this.isCollapsed = doCollapse;
		}
	}, {
		key: "watch",
		value: function watch() {
			this.button.addEventListener("click", this.toggle.bind(this));
			this.attributeObserver.observe(this.element, { attributes: true });
		}
	}, {
		key: "toggleWithHidden",
		value: function toggleWithHidden(doCollapse) {
			this.button.setAttribute("aria-expanded", !doCollapse);

			if (!this.content) {
				return false;
			}
			this.content.hidden = doCollapse;
		}
	}, {
		key: "toggleWithClass",
		value: function toggleWithClass(doCollapse) {
			this.button.setAttribute("aria-expanded", !doCollapse);

			if (!this.content) {
				return false;
			}
			if (doCollapse) {
				this.content.classList.add(this.collapsedClass);
			} else {
				this.content.classList.remove(this.collapsedClass);
			}
		}

		// button click handler

	}, {
		key: "toggle",
		value: function toggle() {
			if (!this.options.selfClosing && !this.isCollapsed) {
				return false;
			}

			var handler = this.isCollapsed ? this.open.bind(this) : this.close.bind(this);
			handler();
		}
	}, {
		key: "open",
		value: function open() {
			this.toggleMethod(false);
			this.isCollapsed = false;
			this.element.dataset.collapsibleOpen = true;
			this.bindDocumentEvents();
		}
	}, {
		key: "close",
		value: function close() {
			this.toggleMethod(true);
			this.isCollapsed = true;
			this.element.dataset.collapsibleOpen = false;
			this.unbindDocumentEvents();
		}
	}, {
		key: "bindDocumentClick",
		value: function bindDocumentClick() {
			document.addEventListener("click", this.onDocumentClick.bind(this));
		}
	}, {
		key: "unbindDocumentClick",
		value: function unbindDocumentClick() {
			document.removeEventListener("click", this.onDocumentClick);
		}
	}, {
		key: "onDocumentClick",
		value: function onDocumentClick(event) {
			var clickTarget = event.target;

			// clicked this.button
			if (clickTarget === this.button || this.button.contains(clickTarget)) {
				return false;
			}

			// clicked this.content
			if (this.content && (clickTarget === this.content || this.content.contains(clickTarget))) {
				return false;
			}

			this.close();
		}
	}, {
		key: "onAttributeChange",
		value: function onAttributeChange(mutationList, observer) {
			mutationList.filter(function (mutation) {
				return mutation.type === "attributes" && mutation.attributeName.startsWith("data-collapsible-open");
			}).forEach(this.onOpenChanged.bind(this));
		}
	}, {
		key: "onOpenChanged",
		value: function onOpenChanged(mutation) {
			var doCollapse = !getJSONValue(this.element.dataset.collapsibleOpen);
			if (this.isCollapsed !== doCollapse) {
				this.toggleMethod(doCollapse);
				this.isCollapsed = doCollapse;
			}
		}
	}]);

	return Collapsible;
}();

Collapsible.DEFAULTS = {
	selfClosing: true
};

exports.default = Collapsible;

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__collapsible/plugin--bundled.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

var _collapsible = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__collapsible/collapsible.js");

var _collapsible2 = _interopRequireDefault(_collapsible);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-collapsible]';
var PLUGIN_NAME = 'Collapsible';

(0, _lib2.default)(PLUGIN_NAME, _collapsible2.default);

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__emit-on-dirty/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-emit-on-dirty]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'EmitOnDirty';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--emit-on-dirty").then(__webpack_require__.bind(null, "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__emit-on-dirty/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__focus-within/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-focus-within]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'FocusWithin';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--focus-within").then(__webpack_require__.bind(null, "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__focus-within/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__focus/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-focus-element]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'FocusElement';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--focus-element").then(__webpack_require__.bind(null, "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__focus/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__remove-element-classes/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-remove-element-classes]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'RemoveElementClasses';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--remove-element-classes").then(__webpack_require__.bind(null, "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__remove-element-classes/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__toggle-element-classes/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-toggle-element-classes]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'ToggleElementClasses';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--toggle-element-classes").then(__webpack_require__.bind(null, "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__toggle-element-classes/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__trigger-event/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-trigger-event]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'triggerEvent';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--trigger-event").then(__webpack_require__.bind(null, "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/jquery__trigger-event/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/fn.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounce = debounce;
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*
                                                                                                                                                                                                                                                                              jQuery plugin
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              import debug from 'debug';
                                                                                                                                                                                                                                                                              import plugin from '@core/plugins/lib';
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              const ELEMENT_SELECTOR = '[data-my-plugin]';
                                                                                                                                                                                                                                                                              const PLUGIN_NAME = 'MyPlugin';
                                                                                                                                                                                                                                                                              const MODULE_NAME = 'plugins/my-plugin';
                                                                                                                                                                                                                                                                              const log = debug(MODULE_NAME);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              class PluginKlass {
                                                                                                                                                                                                                                                                                  constructor(element, options) {
                                                                                                                                                                                                                                                                                    log('new instance', element, options);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                                    this.element = element;
                                                                                                                                                                                                                                                                                    this.options = options;
                                                                                                                                                                                                                                                                                    this.$element = $(element);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                                    log('ready', this.$element);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                                    this.init();
                                                                                                                                                                                                                                                                                  }
                                                                                                                                                                                                                                                                              }
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              PluginKlass.DEFAULTS = {
                                                                                                                                                                                                                                                                                someCamelCasedProperty: `${PLUGIN_NAME}:something`,
                                                                                                                                                                                                                                                                              };
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              plugin(PLUGIN_NAME, PluginKlass);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              $(document).ready(() => {
                                                                                                                                                                                                                                                                                $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
                                                                                                                                                                                                                                                                              });
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              Then using it in html:
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              <div class="something-else"
                                                                                                                                                                                                                                                                                   data-my-plugin
                                                                                                                                                                                                                                                                                   data-my-plugin--some-camel-cased-property="a-string:something-else"></div>
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              Styelguide Core.Global.Javascript.JqueryPlugin
                                                                                                                                                                                                                                                                              */

// import * as events from './events';

exports.default = plugin;
exports.jquery = jquery;
exports.defaults = defaults;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _fn = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/fn.js");

var fn = _interopRequireWildcard(_fn);

var _strings = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/strings.js");

var strings = _interopRequireWildcard(_strings);

var _objects = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/objects.js");

var objects = _interopRequireWildcard(_objects);

var _selectors = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/selectors.js");

var selectors = _interopRequireWildcard(_selectors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('core/plugins/lib');

function plugin(pluginName, klass) {
  var shortHand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var formattedPluginName = (0, _strings.toCamelCase)(pluginName);
  var dataName = '__' + formattedPluginName;
  var old = _jquery2.default.fn[formattedPluginName];
  var ZERO = 0;

  klass.$bus = {
    subscribe: function subscribe(event, fn) {
      (0, _jquery2.default)(this).bind(event, fn);
    },
    publish: function publish(event, data) {
      (0, _jquery2.default)(this).trigger(event, [data]);
    }
  };

  klass.$util = {
    fn: fn,
    objects: objects,
    strings: strings,
    selectors: selectors
  };

  klass.prototype.selectors = selectors;
  klass.prototype.strings = strings;
  klass.prototype.objects = objects;
  klass.prototype.fn = fn;
  klass.prototype.inViewport = function (elm) {
    var rect = elm.getBoundingClientRect();
    var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
  };

  _jquery2.default.fn[pluginName] = function PluginFactory(option) {
    return this.each(function PluginInstanceFactory() {
      var $this = (0, _jquery2.default)(this);
      var data = $this.data();
      var overrides = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object' && option;
      var elementOptions = Object.keys(data).filter(function (key) {
        return (0, _strings.toCamelCase)(key).indexOf(formattedPluginName) >= ZERO;
      }).reduce(function (result, path) {
        var data = path && $this.data(path);
        var key = (0, _strings.toCamelCase)(path.replace(new RegExp(formattedPluginName + '-?'), ''));
        log(path, key, $this.data(path));

        if (key && data !== undefined) {
          result[key] = data;
        }
        return result;
      }, {});
      log(pluginName, { elementOptions: elementOptions });
      var instance = $this.data(dataName);
      var options = _jquery2.default.extend({}, klass.DEFAULTS, elementOptions, overrides);

      // store reference to instance
      if (!instance) {
        instance = new klass(this, options);
        instance.$utils = klass.$util;
        $this.data(dataName, instance);
        $this.addClass('u-' + pluginName);
      }

      // execute instance method
      if (typeof option === 'string') {
        instance[option]();
      }
    });
  };

  // - Short hand
  if (shortHand) {
    _jquery2.default[formattedPluginName] = function (options) {
      return (0, _jquery2.default)({})[formattedPluginName](options);
    };
  }

  // - No conflict
  // $.fn[formattedPluginName].noConflict = function noConflict () {
  //   $.fn[formattedPluginName] = old;
  // };
}

function jquery(name) {
  return function decorate(target) {
    plugin(name, target);
  };
}

function defaults(options) {
  return function decorate(target) {
    target.DEFAULTS = options;
  };
}

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/objects.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elementAttrtibutesToObject = elementAttrtibutesToObject;
exports.objectPath = objectPath;

var _debug = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _strings = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/strings.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'app.core/lib/objects';
var log = (0, _debug2.default)(MODULE_NAME);

var ZERO = 0;

/**
 * Convert an elements attributes to an object, optionally filtering based on some predicate.
 * @param  {DOMElement}   element  [description]
 * @param  {Function} filterFn filtering function. return false to omit attribute.
 * @param  {Function} transformFn transform attribute name function. returns camelCase by default
 * @return {[type]}            [description]
 */
function elementAttrtibutesToObject(element) {
  var filterFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return true;
  };
  var transformFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (name) {
    return (0, _strings.toCamelCase)(name);
  };

  var output = {};
  var attrs = Array.from($(element).get(ZERO).attributes);

  if (!attrs) {
    return output;
  }

  log('converting element attributes to object', attrs);

  return attrs.reduce(function (result, attribute) {
    if (filterFn(attribute)) {
      var name = transformFn(attribute.name);
      var value = attribute.value;

      if (value === 'false' || value === 'true') {
        value = Boolean(value);
      }
      result[name] = attribute.value;
    }

    return result;
  }, output);
}

/**
 * Object.prop()
 *
 * Allows dot-notation access to object properties for both getting and setting.
 *
 * @param {Object} obj    The object we're getting from or setting
 * @param {string} prop   The dot-notated string defining the property location
 * @param {mixed}  val    For setting only; the value to set
 */

function objectPath(obj, path, val) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { delimiter: '.' };

  var props = path.split(options.delimiter);
  var final = props.pop();
  var part = void 0;

  for (var index = 0; index < props.length; index++) {
    part = props[index];
    if (typeof obj[part] === 'undefined') {
      // If we're setting
      if (typeof val !== 'undefined' && index != props.length) {
        // If we're not at the end of the props, keep adding new empty objects
        obj[part] = {};
      } else {
        return undefined;
      }
    }
    obj = obj[part];
  }
  return typeof val !== "undefined" ? obj[final] = val : obj[final];
}

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SELECTOR_PATTERNS = undefined;
exports.selectorPattern = selectorPattern;
exports.selectTarget = selectTarget;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('core/plugins/lib/selectors');

function selectorPattern() {
  for (var _len = arguments.length, directives = Array(_len), _key = 0; _key < _len; _key++) {
    directives[_key] = arguments[_key];
  }

  return new RegExp('\\((' + directives.join('|') + ')(.*)\\)\\s?(.*)');
}

var SELECTOR_PATTERNS = exports.SELECTOR_PATTERNS = {

  // .find
  "children": selectorPattern('children'),

  // .closest
  "parent": selectorPattern('parent'),
  "from": selectorPattern('from'),
  "parents": selectorPattern('parents'),
  "siblings": selectorPattern('siblings'),
  "here": selectorPattern('here'),
  "self": selectorPattern('self')
};

function selectTarget(selector, $element) {
  var $target = void 0;

  var isClosestAncestoral = selector.match(SELECTOR_PATTERNS.parent);
  var isAllAncestoral = selector.match(SELECTOR_PATTERNS.parents);
  var isRetargeted = selector.match(SELECTOR_PATTERNS.from);
  var isAllDescendants = selector.match(SELECTOR_PATTERNS.children);
  var isGenerational = selector.match(SELECTOR_PATTERNS.here);
  var isSiblings = selector.match(SELECTOR_PATTERNS.siblings);
  var isSelfish = selector.match(SELECTOR_PATTERNS.self);

  // special retargeting root
  if (isRetargeted) {
    log('isRetargeted', isRetargeted[2], isRetargeted[3]);
    var $newElement = selectTarget(isRetargeted[2], $element);
    var newSelector = '(children) ' + isRetargeted[3];
    log('isRetargeted.newElement', $newElement);
    log('isRetargeted.newSelector', newSelector);
    $target = selectTarget(newSelector, $newElement);
    log('isRetargeted.target', $target);
  }

  // target is all ancestors
  else if (isAllAncestoral) {
      log('isAllAncestoral', isAllAncestoral);
      $target = $element.parents(isAllAncestoral[isAllAncestoral.length - 1]);
    }
    // target is closest ancestor
    else if (isClosestAncestoral) {
        log('isClosestAncestoral', isClosestAncestoral);
        $target = $element.closest(isClosestAncestoral[isClosestAncestoral.length - 1]);
      }
      // target is somewhere under current parent
      else if (isGenerational) {
          log('isGenerational', isGenerational);
          $target = $element.parent().find(isGenerational[isGenerational.length - 1]);
        }
        // target is only under self
        else if (isAllDescendants) {
            log('isAllDescendants', isAllDescendants);
            $target = $element.find(isAllDescendants[isAllDescendants.length - 1]);
          }
          // target is somewhere in siblings only
          else if (isSiblings) {
              log('isSiblings', isSiblings);
              $target = $element.siblings(isSiblings[isSiblings.length - 1]);
            }
            // target is source
            else if (!selector || isSelfish) {
                log('isSelfish', isSelfish);
                var selector = isSelfish[isSelfish.length - 1] || '*';
                $target = $element.filter(selector);
              }
              // target could be anywhere
              else {
                  log('global', selector);
                  $target = (0, _jquery2.default)(selector);
                }
  return $target;
}

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/plugins/lib/strings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.toCamelCase = toCamelCase;
exports.tmpl = tmpl;
exports.$tmpl = $tmpl;
exports.mustache = mustache;
exports.booleanify = booleanify;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('core/jquery_plugin/strings');

function preserveCamelCase(str) {
  var isLastCharLower = false;
  var isLastCharUpper = false;
  var isLastLastCharUpper = false;

  for (var i = 0; i < str.length; i++) {
    var c = str[i];

    if (isLastCharLower && /[a-zA-Z]/.test(c) && c.toUpperCase() === c) {
      str = str.substr(0, i) + '-' + str.substr(i);
      isLastCharLower = false;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = true;
      i++;
    } else if (isLastCharUpper && isLastLastCharUpper && /[a-zA-Z]/.test(c) && c.toLowerCase() === c) {
      str = str.substr(0, i - 1) + '-' + str.substr(i - 1);
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = false;
      isLastCharLower = true;
    } else {
      isLastCharLower = c.toLowerCase() === c;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = c.toUpperCase() === c;
    }
  }

  return str;
}

function toCamelCase(str) {
  if (arguments.length > 1) {
    str = Array.from(arguments).map(function (x) {
      return x.trim();
    }).filter(function (x) {
      return x.length;
    }).join('-');
  } else {
    str = str.trim();
  }

  if (str.length === 0) {
    return '';
  }

  if (str.length === 1) {
    return str.toLowerCase();
  }

  if (/^[a-z0-9]+$/.test(str)) {
    return str;
  }

  var hasUpperCase = str !== str.toLowerCase();

  if (hasUpperCase) {
    str = preserveCamelCase(str);
  }

  return str.replace(/^[_.\- ]+/, '').toLowerCase().replace(/[_.\- ]+(\w|$)/g, function (m, p1) {
    return p1.toUpperCase();
  });
};

function tmpl(str, context) {
  var result = str;

  if (result) {

    Object.keys(context).forEach(function (item) {
      result = result.replace('{{' + item + '}}', context[item]);
    });
  }

  return result;
}

function $tmpl(element, context) {
  var $target = (0, _jquery2.default)(element);
  var templateString = $target.attr('data-text-template');
  var result = tmpl(templateString, context);

  $target.text(result);
}

/**
 * https://github.com/aishikaty/tiny-mustache
 * https://mustache.github.io/
 * @param  {String} template [description]
 * @param  {[type]} self     [description]
 * @param  {[type]} parent   [description]
 * @param  {[type]} invert   [description]
 * @return {[type]}          [description]
 */
function mustache(template, self, parent, invert) {
  var render = mustache;
  var output = "";
  var i;

  log('mustache', { template: template, self: self, parent: parent, invert: invert });

  function get(ctx, path) {
    path = path.pop ? path : path.split(".");
    ctx = ctx[path.shift()] || "";
    return 0 in path ? get(ctx, path) : ctx;
  }

  self = Array.isArray(self) ? self : self ? [self] : [];
  self = invert ? 0 in self ? [] : [1] : self;

  for (i = 0; i < self.length; i++) {
    var childCode = '';
    var depth = 0;
    var inverted;
    var ctx = _typeof(self[i]) == "object" ? self[i] : {};
    ctx = Object.assign({}, parent, ctx);
    ctx[""] = { "": self[i] };

    template.replace(/([\s\S]*?)({{((\/)|(\^)|#)(.*?)}}|$)/g, function (match, code, y, z, close, invert, name) {

      if (!depth) {
        output += code.replace(/{{{(.*?)}}}|{{(!?)(&?)(>?)(.*?)}}/g, function (match, raw, comment, isRaw, partial, name) {
          return raw ? get(ctx, raw) : isRaw ? get(ctx, name) : partial ? render(get(ctx, name), ctx) : !comment ? new Option(get(ctx, name)).innerHTML : "";
        });
        inverted = invert;
      } else {
        childCode += depth && !close || depth > 1 ? match : code;
      }

      if (close) {
        if (! --depth) {
          name = get(ctx, name);
          if (/^f/.test(typeof name === 'undefined' ? 'undefined' : _typeof(name))) {
            output += name.call(ctx, childCode, function (template) {
              return render(template, ctx);
            });
          } else {
            output += render(childCode, name, ctx, inverted);
          }
          childCode = "";
        }
      } else {
        ++depth;
      }
      log('mustache.output.' + depth, { output: output });
    });
  }
  log('mustache.output', { output: output });
  return output;
}

function booleanify(value) {
  var lower = value.toLowerCase();
  if (lower === 'false' || lower === '0') {
    return false;
  }
  return new Boolean(value);
}

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/node_modules/debug/node_modules/ms/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {};
  var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/node_modules/debug/src/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

/* eslint-env browser */

/**
 * This is the web browser implementation of `debug()`.
 */
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
/**
 * Colors.
 */

exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */
// eslint-disable-next-line complexity

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
    return true;
  } // Internet Explorer and Edge do not support colors.


  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  } // Is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632


  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);

  if (!this.useColors) {
    return;
  }

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit'); // The final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into

  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function (match) {
    if (match === '%%') {
      return;
    }

    index++;

    if (match === '%c') {
      // We only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });
  args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  var _console;

  // This hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return (typeof console === "undefined" ? "undefined" : _typeof(console)) === 'object' && console.log && (_console = console).log.apply(_console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (namespaces) {
      exports.storage.setItem('debug', namespaces);
    } else {
      exports.storage.removeItem('debug');
    }
  } catch (error) {// Swallow
    // XXX (@Qix-) should we be logging these?
  }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;

  try {
    r = exports.storage.getItem('debug');
  } catch (error) {} // Swallow
  // XXX (@Qix-) should we be logging these?
  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG


  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
    // The Browser also has localStorage in the global context.
    return localStorage;
  } catch (error) {// Swallow
    // XXX (@Qix-) should we be logging these?
  }
}

module.exports = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/node_modules/debug/src/common.js")(exports);
var formatters = module.exports.formatters;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

formatters.j = function (v) {
  try {
    return JSON.stringify(v);
  } catch (error) {
    return '[UnexpectedJSONParseError]: ' + error.message;
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/node_modules/process/browser.js")))

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/node_modules/debug/src/common.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */

function setup(env) {
  createDebug.debug = createDebug;
  createDebug.default = createDebug;
  createDebug.coerce = coerce;
  createDebug.disable = disable;
  createDebug.enable = enable;
  createDebug.enabled = enabled;
  createDebug.humanize = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/node_modules/debug/node_modules/ms/index.js");
  Object.keys(env).forEach(function (key) {
    createDebug[key] = env[key];
  });
  /**
  * Active `debug` instances.
  */

  createDebug.instances = [];
  /**
  * The currently active debug mode names, and names to skip.
  */

  createDebug.names = [];
  createDebug.skips = [];
  /**
  * Map of special "%n" handling functions, for the debug "format" argument.
  *
  * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
  */

  createDebug.formatters = {};
  /**
  * Selects a color for a debug namespace
  * @param {String} namespace The namespace string for the for the debug instance to be colored
  * @return {Number|String} An ANSI color code for the given namespace
  * @api private
  */

  function selectColor(namespace) {
    var hash = 0;

    for (var i = 0; i < namespace.length; i++) {
      hash = (hash << 5) - hash + namespace.charCodeAt(i);
      hash |= 0; // Convert to 32bit integer
    }

    return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
  }

  createDebug.selectColor = selectColor;
  /**
  * Create a debugger with the given `namespace`.
  *
  * @param {String} namespace
  * @return {Function}
  * @api public
  */

  function createDebug(namespace) {
    var prevTime;

    function debug() {
      // Disabled?
      if (!debug.enabled) {
        return;
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var self = debug; // Set `diff` timestamp

      var curr = Number(new Date());
      var ms = curr - (prevTime || curr);
      self.diff = ms;
      self.prev = prevTime;
      self.curr = curr;
      prevTime = curr;
      args[0] = createDebug.coerce(args[0]);

      if (typeof args[0] !== 'string') {
        // Anything else let's inspect with %O
        args.unshift('%O');
      } // Apply any `formatters` transformations


      var index = 0;
      args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
        // If we encounter an escaped % then don't increase the array index
        if (match === '%%') {
          return match;
        }

        index++;
        var formatter = createDebug.formatters[format];

        if (typeof formatter === 'function') {
          var val = args[index];
          match = formatter.call(self, val); // Now we need to remove `args[index]` since it's inlined in the `format`

          args.splice(index, 1);
          index--;
        }

        return match;
      }); // Apply env-specific formatting (colors, etc.)

      createDebug.formatArgs.call(self, args);
      var logFn = self.log || createDebug.log;
      logFn.apply(self, args);
    }

    debug.namespace = namespace;
    debug.enabled = createDebug.enabled(namespace);
    debug.useColors = createDebug.useColors();
    debug.color = selectColor(namespace);
    debug.destroy = destroy;
    debug.extend = extend; // Debug.formatArgs = formatArgs;
    // debug.rawLog = rawLog;
    // env-specific initialization logic for debug instances

    if (typeof createDebug.init === 'function') {
      createDebug.init(debug);
    }

    createDebug.instances.push(debug);
    return debug;
  }

  function destroy() {
    var index = createDebug.instances.indexOf(this);

    if (index !== -1) {
      createDebug.instances.splice(index, 1);
      return true;
    }

    return false;
  }

  function extend(namespace, delimiter) {
    return createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
  }
  /**
  * Enables a debug mode by namespaces. This can include modes
  * separated by a colon and wildcards.
  *
  * @param {String} namespaces
  * @api public
  */

  function enable(namespaces) {
    createDebug.save(namespaces);
    createDebug.names = [];
    createDebug.skips = [];
    var i;
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;

    for (i = 0; i < len; i++) {
      if (!split[i]) {
        // ignore empty strings
        continue;
      }

      namespaces = split[i].replace(/\*/g, '.*?');

      if (namespaces[0] === '-') {
        createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
      } else {
        createDebug.names.push(new RegExp('^' + namespaces + '$'));
      }
    }

    for (i = 0; i < createDebug.instances.length; i++) {
      var instance = createDebug.instances[i];
      instance.enabled = createDebug.enabled(instance.namespace);
    }
  }
  /**
  * Disable debug output.
  *
  * @api public
  */

  function disable() {
    createDebug.enable('');
  }
  /**
  * Returns true if the given mode name is enabled, false otherwise.
  *
  * @param {String} name
  * @return {Boolean}
  * @api public
  */

  function enabled(name) {
    if (name[name.length - 1] === '*') {
      return true;
    }

    var i;
    var len;

    for (i = 0, len = createDebug.skips.length; i < len; i++) {
      if (createDebug.skips[i].test(name)) {
        return false;
      }
    }

    for (i = 0, len = createDebug.names.length; i < len; i++) {
      if (createDebug.names[i].test(name)) {
        return true;
      }
    }

    return false;
  }
  /**
  * Coerce `val`.
  *
  * @param {Mixed} val
  * @return {Mixed}
  * @api private
  */

  function coerce(val) {
    if (val instanceof Error) {
      return val.stack || val.message;
    }

    return val;
  }

  createDebug.enable(createDebug.load());
  return createDebug;
}

module.exports = setup;

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/node_modules/process/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),

/***/ "/home/vsts/work/1/s/src/SCF/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--14-0!/home/vsts/work/1/s/src/SCF/node_modules/css-loader/index.js??ref--14-1!/home/vsts/work/1/s/src/SCF/node_modules/postcss-loader/lib/index.js??ref--14-2!/home/vsts/work/1/s/src/SCF/node_modules/sass-loader/lib/loader.js??ref--14-3!/home/vsts/work/1/s/src/SCF/client/src/core/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "external \"jQuery\"":
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ "multi /home/vsts/work/1/s/src/SCF//client/src/core/index.js /home/vsts/work/1/s/src/SCF//client/src/core/index.scss":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/babel-loader/lib/index.js??ref--11-0!/home/vsts/work/1/s/src/SCF/node_modules/eslint-loader/index.js!/home/vsts/work/1/s/src/SCF/client/src/core/index.js");
module.exports = __webpack_require__("/home/vsts/work/1/s/src/SCF/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--14-0!/home/vsts/work/1/s/src/SCF/node_modules/css-loader/index.js??ref--14-1!/home/vsts/work/1/s/src/SCF/node_modules/postcss-loader/lib/index.js??ref--14-2!/home/vsts/work/1/s/src/SCF/node_modules/sass-loader/lib/loader.js??ref--14-3!/home/vsts/work/1/s/src/SCF/client/src/core/index.scss");


/***/ })

},["multi /home/vsts/work/1/s/src/SCF//client/src/core/index.js /home/vsts/work/1/s/src/SCF//client/src/core/index.scss"]);


// WEBPACK FOOTER //
// scripts/core--b22ea8b77afb3a377e7f.js